// @flow

import React, { useMemo, type Node } from 'react';

import { type UserInputValues, type SetUserInputValue } from './types';
import { UserInputValuesContext } from './context';

type Props = {|
  +values: UserInputValues,
  +setValue: SetUserInputValue,
  +children: Node,
|};

export function UserInputValuesProvider({ values, setValue, children }: Props): Node {
  const contextValue = useMemo(
    () => [values, setValue],
    [values, setValue],
  );

  return (
    <UserInputValuesContext.Provider value={contextValue}>
      {children}
    </UserInputValuesContext.Provider>
  );
}
